<eo-search-page
  [formConfig]="formConfig"
  [tableConfig]="tableConfig"
  [searchServ]="searchService"
  [page]="getPage()"
  [pagesize]="getPagesize()"
  [totalCount]="getTotalCount()"
  [loading]="isLoading()"
  [viewModeVisible]="false"
  [menuActions]="[]"
  (search)="onSearch($event)"
>
  <ng-container actions>
    <p-button
      size="small"
      label="Νέος Χρήστης"
      icon="pi pi-plus"
      [disabled]="isLoading()"
      (onClick)="onCreateUser()"
    />
  </ng-container>
</eo-search-page>

<app-user-form-dialog #userFormDialog (success)="onUserFormSuccess()" />

<p-confirmPopup key="approveResetPopup" [style]="{ width: '700px' }">
</p-confirmPopup>
